import { i18n } from "translate/i18n";

export const genesis = i18n.t("messages.bibleBooks.genesis.abbreviation");
export const revelation = i18n.t("messages.bibleBooks.revelation.abbreviation");
